jQuery(document).ready(async function ($) {
	// lets destructure our vars passed from php, for readability later
	const {
		enabled, pum_id, gform_id, form_handler_endpoint, url_params
	} = downloadable_email_popup;

	// only run any of this if enabled in php: set in DownloadableItemLoop
	if (!enabled) {
		return;
	}

	// don't run this script if the popup doesn't exist on the page
	if (0 === window.PUM.getPopup(pum_id).length) {
		return;
	}

	// popup opening
	// ----

	const selectorButton = $('a.button.download');
	const resourceItemLink = selectorButton.attr('href');
	const PUMCookie = `pum-${pum_id}`;

	// wrapped in func so will return correct once the form half-reloads the page
	const getPUMCookie = async () => {
		// if we don't have cookieStore, let's do a backup
		if (!window.cookieStore) {
			const cookies = document.cookie.split('; ');
			const targetCookie = cookies.find(cookie => {
				return cookie.startsWith(PUMCookie)
			});

			// bail out our undefined cookie early, so we can do string manipulation without
			// worry
			if (undefined === targetCookie) {
				return undefined;
			}

			// use split to chop off the top of the string, then return the unsplit string
			return targetCookie.split(`${PUMCookie}=`)[1];
		}
		return await window.cookieStore.get(PUMCookie);
	}

	const openDownloadForm = async (e) => {
		e.preventDefault();

		if (await getPUMCookie()) {
			downloadResource();
		} else {
			window.PUM.open(pum_id)
		}
	}

	const downloadResource = () => {
		// first, we try to use the default browser method to open the download in a new tab.
		// this will LIKELY work when the user clicks the download button, but if we try to
		// trigger this with the form submission, browser popup blockers might prevent us. bc
		// this, we save the return value of our first open attempt, and if it fails, we use
		// some dom manipulation to, like a scummy gambling website, work around. it _does_ have
		// issues if repeatedly run on safari
		const hasDownloadOpened = window.open(
			resourceItemLink,
			'resourceItemTab'
		);

		if (!hasDownloadOpened) {
			const dummyLink = document.createElement("a");
			dummyLink.style.display = "none";
			dummyLink.href = resourceItemLink;
			dummyLink.download = "";
			dummyLink.target = "_blank";

			document.body.appendChild(dummyLink);
			dummyLink.click();

			// To make this work on Firefox we need to wait
			// a little while before removing it.
			setTimeout(() => {
				URL.revokeObjectURL(dummyLink.href);
				dummyLink.parentNode.removeChild(dummyLink);
			}, 0);
		}

	}

	// event listener for it
	selectorButton.on('click', openDownloadForm);


	// form handler hijacking
	// ---

	// we need a variable in scope outside of function so as to reference it between func calls
	let pardotDataSent = false;
	const submitButton = document.getElementById(`gform_submit_button_${gform_id}`)
	submitButton.addEventListener('click', e => {
		if (!pardotDataSent) {
			e.preventDefault()

			const formElement = document.getElementById(`gform_${gform_id}`);
			const downloadForm = new FormData(formElement);

			// create the URL params options out of what we've passed from DownloadableItemPopup
			const urlParamsOptions = {}
			for (const gformLabel in url_params) {
				const pardotLabel = url_params[gformLabel];
				urlParamsOptions[pardotLabel] = downloadForm.get(gformLabel);
			}
			const urlParam = new URLSearchParams(urlParamsOptions);
			const targetUrl = form_handler_endpoint + '?' + urlParam.toString();

			// send the data to Pardot
			// NOTE: because of how Pardot handles cross-origin requests, this returns a 404 error
			// basically no matter what. this is obviously annoying, possibly impactful, for our
			// site's side of the equation BUT from all the testing i've done, this still adds
			// contacts to the Pardot form handler. the only way around this (from what i understand
			// of Pardot documentation) is to create an endpoint on our own server just for this
			// request, and halfway-trick the form handler to redirect there with a javascript url.
			// thus, for now, we let the error stand, and run our continued functionality within
			// an `always`, with the philosophy we let this appear seamless to the user
			const test = $.ajax({
				url: targetUrl, type: 'GET', dataType: 'jsonp', crossDomain: true
			}).always(() => {
				pardotDataSent = true; // so we don't double-send
				// technically PUM should be handling this, but i believe they set their submit
				// event listener to only run once.
				document.cookie = `${PUMCookie}=true`;
				downloadResource();
				// run this again
				submitButton.closest('form').submit();
			});
		}
	})
});
